import React from "react";
import "./style.scss";

export const MarkAdapter = ({ labels, MatchScores }) => {
    return (
        <table className="table-mark-adapter">
            <tbody>
               {!Utils.isMobile()? 
               <tr className="tr-titles">
                    <th className="td-r">{labels.suitability_engineering}</th>
                    <th className="td-r">{labels.suitability_exact_sciences}</th>
                    <th className="td-r">{labels.suitability_no_more}</th>
                    <th className="td-r">{labels.suitability_manage}</th>
                </tr>:
                <tr className="tr-titles">
                    <td className="td-r">{labels.suitability_engineering}</td>
                    <td className="td-r">{labels.suitability_exact_sciences}</td>
                    <td className="td-r">{labels.suitability_no_more}</td>
                    <td className="td-r">{labels.suitability_manage}</td>
                </tr>}
                <tr className={window.location.href.includes("triple") ? "tr-triple" : "tr-r"}>
                    <td>{MatchScores?.hatama_handasa}</td>
                    <td>{MatchScores?.hatama_meduyakim}</td>
                    <td>{MatchScores?.hatama_refua}</td>
                    <td>{MatchScores?.hatama_nihul}</td>
                </tr>
            </tbody>
        </table>
    );
}